// @flow
type WithCountFunctions = {
  one: (count?: number) => string,
  other: (count: number) => string,
  zero?: (count: number) => string,
}

export const stringWithCount = ({ one, other, zero }: WithCountFunctions) => (
  count: number,
) => {
  if (zero && count === 0) {
    return zero(count)
  }

  if (count === 1) {
    return one(count)
  }

  return other(count)
}

export const isRelativeUrl = (url: string): boolean => url[0] === '/'



// WEBPACK FOOTER //
// ./src/utils.js